import { status } from '../../config.ts'
import { serviceRechargeInvoicesPage1 } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'POST',
    path: '/billing/pay-service-quotes',
    reply: async () => {
      await wait()
      return [status.ok, serviceRechargeInvoicesPage1]
    }
  }
]
